import React, { useEffect, useRef } from "react";
import { BiFilterAlt } from "react-icons/bi";
import { IoCloseSharp } from "react-icons/io5";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store/store";
import { Category, FilterValue } from "./QuestionsLeftPane";

type FiltersPopupType = {
  setShowFilters: (val: boolean) => void;
  showFilters: boolean;
  toggleFilter: (val1: Category, val2: FilterValue) => void;
};

const FiltersPopUp = ({
  setShowFilters,
  showFilters,
  toggleFilter,
}: FiltersPopupType) => {
  const { filters } = useSelector(
    (state: RootState) => state.root.startFullTest
  );

  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        setShowFilters(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowFilters]);

  return (
    <div
      ref={popupRef}
      className="absolute w-[282px] left-5 top-5 bg-satPrepTransWhite shadow-widget-card rounded-xl backdrop-blur-sevenFive border-[0.5px] border-satPrepGrey px-4 z-10"
    >
      <div className="flex items-center justify-between py-[18px]">
        <div className="flex items-center gap-3 text-satPrepAccent">
          <button
            onClick={() => setShowFilters(!showFilters)}
            className=" hover:bg-gray-100 rounded"
          >
            <BiFilterAlt size={24} className="font-medium" />
          </button>
          <p className="text-xl">Filters</p>
        </div>
        <button
          onClick={() => setShowFilters(!showFilters)}
          className="p-1 hover:bg-gray-100 rounded"
        >
          <IoCloseSharp
            size={24}
            className="font-medium text-satPrepAccent"
          />
        </button>
      </div>
      <div className="mb-1">
        <div className="border-b border-satPrepGrey pb-2">
          <h3 className="font-semibold font-gully text-sm mb-2 text-satPrepXDarkAccent">
            Section
          </h3>
          <label className="mb-5 custom-checkbox text-satPrepBlack font-medium">
            Reading & Writing Section
            <input
              type="checkbox"
              checked={filters.section.readingWriting}
              onChange={() => toggleFilter("section", "readingWriting")}
            />
            <span className="filterCheckmark" />
          </label>
          <label className="custom-checkbox mb-2 text-satPrepBlack font-medium">
            Math{" "}
            <input
              type="checkbox"
              checked={filters.section.math}
              onChange={() => toggleFilter("section", "math")}
            />
            <span className="filterCheckmark" />
          </label>
        </div>

        <div className="border-b border-satPrepGrey py-2">
          <h3 className="font-semibold text-sm mb-2 text-satPrepXDarkAccent">
            Module
          </h3>
          <label className="flex items-center gap-2 mb-5 custom-checkbox text-satPrepBlack font-medium">
            <input
              type="checkbox"
              checked={filters.module.module1}
              onChange={() => toggleFilter("module", "module1")}
            />{" "}
            Module 1 <span className="filterCheckmark" />
          </label>

          <label className="flex items-center gap-2 custom-checkbox text-satPrepBlack font-medium">
            <input
              type="checkbox"
              checked={filters.module.module2}
              onChange={() => toggleFilter("module", "module2")}
            />{" "}
            Module 2 <span className="filterCheckmark" />
          </label>
        </div>

        <div className="py-2">
          <h3 className="font-semibold text-sm mb-2 text-satPrepXDarkAccent">
            Answer Type
          </h3>
          <label className="flex items-center gap-2 mb-5 custom-checkbox text-satPrepBlack font-medium">
            <input
              type="checkbox"
              checked={filters.answerType.correct}
              onChange={() => toggleFilter("answerType", "correct")}
            />{" "}
            Correct <span className="filterCheckmark" />
          </label>
          <label className="flex items-center gap-2 custom-checkbox mb-5 text-satPrepBlack font-medium">
            <input
              type="checkbox"
              checked={filters.answerType.incorrect}
              onChange={() => toggleFilter("answerType", "incorrect")}
            />{" "}
            Incorrect <span className="filterCheckmark" />
          </label>
          <label className="flex items-center gap-2 custom-checkbox text-satPrepBlack font-medium">
            <input
              type="checkbox"
              checked={filters.answerType.omitted}
              onChange={() => toggleFilter("answerType", "omitted")}
            />{" "}
            Skipped <span className="filterCheckmark" />
          </label>
        </div>
      </div>
    </div>
  );
};

export default FiltersPopUp;
